import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Avatar_List,
  Avatar_delete,
  Poster_delete,
  Categories_delete,
  Categories_list,
  Genres_delete,
  Genres_list,
  Languages_delete,
  Languages_list,
  MatuarityRatings_ListData_list,
  MatuarityRatings_delete,
  Theme_delete,
  Theme_list,
  setLangPriority,
  Posters_List,
  SetActiveInactive,
  Question_delete,
  Question_List,
} from "../../api/api";
import "../../assets/css/style.scss";
import deleteIcon from "../../assets/images/DeleteIcon.svg";
import editIcon from "../../assets/images/EditIcon.svg";
import viewIcon from "../../assets/images/ViewIcon.svg";
import addIcon from "../../assets/images/addIcon.svg";
import desc from "../../assets/images/desc.png";
import img_thumb from "../../assets/images/image-thum.png";
import sort from "../../assets/images/sort.png";
import filter_alt from "../../assets/images/sortarrow.png";
import Pagination from "../../component/Common/Pagination";
import Loader from "../../component/Loader/Loader";
import ErrorPopup from "../../component/popup/ErrorPopup";
import AddEditSettingspopup from "../../component/popup/master-settings/AddEditSettingspopup";
import {
  columns,
  priorityList,
  subTabs,
  tabs,
} from "../../dummyjson/masterSettingsDefaultValues";
import {
  ActiveInactiveAvatar_URL,
  ActiveInactivePoster_URL,
  ActiveInactiveQuestion_URL,
  cloudFront_URL,
} from "../../service/API_URL";
import { permissionDetails } from "../../utility/localStoageData";
import "./MasterSettings.scss";
import DropDown from "../../component/Common/DropDown";

function MasterSettings() {
  const [tabContent, setTabContent] = useState({
    Themes: [],
    Categories: [],
    Genres: [],
    Languages: [],
    MatuarityRatings: [],
    Avatar: [],
  });

  const [pageSize, setPageSize] = useState(10);
  const [showPopup, setShowPopup] = useState(false);
  const [createEdit, setCreateEdit] = useState("create");
  const [viewonly, setviewonly] = useState(false);
  const [singledata, setSingleData] = useState(null);
  const [ShowLoader, setShowLoader] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [numberOfElement, setNumberOfElement] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [activeTab, setActiveTab] = useState("Themes");
  const [activeSubTab, setActiveSubTab] = useState("Posters");
  const [pageJump, setPageJump] = useState(0);
  const [masterSettingsData, setMasterSettingsData] = useState([]);
  const [permission, setpermission] = useState(null);
  const [identifier, setIdentifier] = useState("");
  const [sortOrders, setSortOrders] = useState({});
  const [errorbox, setErrorbox] = useState(false);
  const [errorMssage, setErrorMssage] = useState("");
  const [deletedata, setDeletedata] = useState(null);
  const [questionData, setQuestionData] = useState([]);
  const [posterData, setPosterData] = useState([]);
  const [avatarData, setAvatarData] = useState([]);

  //add partner pop
  const openCreatePopup = () => {
    setCreateEdit("create");
    setShowPopup(true);
    setviewonly(false);
  };

  const openEditPopup = (data) => {
    console.log("data edit", data);
    setCreateEdit("edit");
    setSingleData(data);
    setShowPopup(true);
    setviewonly(false);
  };
  const openviewPopup = (data) => {
    setviewonly(true);
    setCreateEdit("edit");
    setSingleData(data);
    setShowPopup(true);
  };

  const deletepopup = (data) => {
    setErrorMssage("Do you want to delete ?");
    setErrorbox(true);
    setDeletedata(data);
  };
  const errorboxclose = () => {
    setErrorbox(false);
    setErrorMssage("");
  };
  const deletesetting = async (data) => {
    let deleted = false;
    setErrorbox(false);
    switch (activeTab) {
      case "Themes":
        deleted = await Theme_delete(data.id);
        break;
      case "Categories":
        deleted = await Categories_delete(data.id);
        break;
      case "Genres":
        deleted = await Genres_delete(data.id);
        break;
      case "Languages":
        deleted = await Languages_delete(data.id);
        break;
      case "Maturity Ratings":
        deleted = await MatuarityRatings_delete(data.id);
        break;
      case "Onboarding":
        if (activeSubTab === "Avatars") {
          deleted = await Avatar_delete(data.id);
        } else if (activeSubTab === "Posters") {
          deleted = await Poster_delete(data.id);
        } else {
          deleted = await Question_delete(data.id);
        }
        break;
      default:
        // Handle default case or unknown tab
        break;
    }
    if (deleted.status === 200) {
      handleTabChange(activeTab);
      toast.success(deleted.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
        style: { color: "#333333", fontWeight: "bold" },
      });
    } else {
      toast.error(deleted.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
        style: { color: "#333333", fontWeight: "bold" },
      });
    }
  };
  const closePopup = () => {
    setShowPopup(false);
    setCreateEdit("create"); // Reset to create mode
    setSingleData(null); // Clear the single data
  };

  const getPermission = () => {
    let findEdit = permissionDetails();
    if (findEdit.includes("MASTER_SETTINGS_EDIT")) setpermission("edit");
    else if (findEdit.includes("MASTER_SETTINGS_READ")) setpermission("read");
    else setpermission(null);
  };
  const accessStore = async () => {
    const tenantLocalData = localStorage.getItem("tenantInfo");
    const tenantLocalDataParse = await JSON.parse(tenantLocalData);
    setIdentifier(tenantLocalDataParse?.code);
  };

  useEffect(() => {
    accessStore();
    getPermission();
    handleTabChange("Themes");
    const initialSortOrders = {
      name: "asc", // Default sort order for 'duration' column
      // name: 'name', // Default sort order for 'filename' column
    };
    setSortOrders(initialSortOrders);
  }, []);

  const filterchanges = (tabName, field) => {
    let currentSortOrder = "asc"; // Default sort order
    // Check if the field was previously sorted and toggle the sort order
    if (sortOrders[field]) {
      currentSortOrder = sortOrders[field] === "desc" ? "asc" : "desc";
    }

    const updatedSortOrders = { ...sortOrders, [field]: currentSortOrder };
    setSortOrders(updatedSortOrders);
    handleTabChange(tabName, field, currentSortOrder);
  };
  const handleTabChange = async (
    tabName,
    field,
    currentSortOrder,
    pageSize
  ) => {
    let pageNo = 0;
    if (tabName === activeTab) {
      pageNo = pageJump;
    }
    setActiveTab(tabName);
    if (tabName === "Onboarding") {
      handleSubTabChange("Posters");
    }
    if (!tabContent[tabName] || tabContent[tabName].length === 0) {
      fetchTabData(tabName, field, currentSortOrder, pageNo, pageSize);
    }
  };

  const handleSubTabChange = async (subTabName) => {
    let pageNo = 0;
    if (subTabName === activeSubTab) {
      pageNo = pageJump;
    }

    const data = {
      searchText: "",
      sortBy: "name",
      sortOrder: "asc",
      pageSize: pageSize,
      pageNumber: pageNo,
      ignorePagination: false,
    };
    setActiveSubTab(subTabName);
    await fetchData(subTabName, data);
  };

  const fetchData = async (tabName, data) => {
    if (tabName === "Onboarding") {
      tabName = activeSubTab;
    }
    switch (tabName) {
      case "Themes":
        const theme_ListData = await Theme_list(data);
        if (theme_ListData) {
          setShowLoader(false);
          setMasterSettingsData(theme_ListData?.content);
          setCurrentPage(theme_ListData?.number);
          setTotalPages(theme_ListData?.totalPages);
          setPageJump(theme_ListData?.number);
          setNumberOfElement(theme_ListData?.totalElements);
          setPageSize(theme_ListData?.size);
        }
        break;

      case "Categories":
        const Categories_ListData = await Categories_list(data);
        if (Categories_ListData) {
          setShowLoader(false);
          setCurrentPage(Categories_ListData?.number);
          setMasterSettingsData(Categories_ListData?.content);
          setTotalPages(Categories_ListData?.totalPages);
          setPageJump(Categories_ListData?.number);
          setNumberOfElement(Categories_ListData?.totalElements);
          setPageSize(Categories_ListData?.size);
        }
        break;

      case "Genres":
        const Genres_ListData = await Genres_list(data);
        if (Genres_ListData) {
          setShowLoader(false);
          setCurrentPage(Genres_ListData?.number);
          setMasterSettingsData(Genres_ListData?.content);
          setTotalPages(Genres_ListData?.totalPages);
          setPageJump(Genres_ListData?.number);
          setNumberOfElement(Genres_ListData?.totalElements);
          setPageSize(Genres_ListData?.size);
        }
        break;

      case "Languages":
        const Languages_ListData = await Languages_list(data);
        if (Languages_ListData) {
          setShowLoader(false);
          setCurrentPage(Languages_ListData?.number);
          setMasterSettingsData(Languages_ListData?.content);
          setTotalPages(Languages_ListData?.totalPages);
          setPageJump(Languages_ListData?.number);
          setNumberOfElement(Languages_ListData?.totalElements);
          setPageSize(Languages_ListData?.size);
        }
        break;

      case "Maturity Ratings":
        const MatuarityRatings_ListData = await MatuarityRatings_ListData_list(
          data
        );
        if (MatuarityRatings_ListData) {
          setShowLoader(false);
          setCurrentPage(MatuarityRatings_ListData?.number);
          setMasterSettingsData(MatuarityRatings_ListData?.content);
          setTotalPages(MatuarityRatings_ListData?.totalPages);
          setPageJump(MatuarityRatings_ListData?.number);
          setNumberOfElement(MatuarityRatings_ListData?.totalElements);
          setPageSize(MatuarityRatings_ListData?.size);
        }
        break;
      case "Posters":
        const Posters_ListData = await Posters_List(data);
        if (Posters_ListData) {
          setShowLoader(false);
          setPosterData(Posters_ListData?.content);
          setCurrentPage(Posters_ListData?.number);
          setTotalPages(Posters_ListData?.totalPages);
          setPageJump(Posters_ListData?.number);
          setNumberOfElement(Posters_ListData?.totalElements);
          setPageSize(Posters_ListData?.size);
        }
        break;
      case "Avatars":
        const Avatar_ListData = await Avatar_List(data);
        if (Avatar_ListData) {
          setShowLoader(false);
          setAvatarData(Avatar_ListData?.content);
          setCurrentPage(Avatar_ListData?.number);
          setTotalPages(Avatar_ListData?.totalPages);
          setPageJump(Avatar_ListData?.number);
          setNumberOfElement(Avatar_ListData?.totalElements);
          setPageSize(Avatar_ListData?.size);
        }
        break;
      case "Questions":
        const Question_ListData = await Question_List(data);
        if (Question_ListData) {
          setShowLoader(false);
          setQuestionData(Question_ListData?.content);
          setCurrentPage(Question_ListData?.number);
          setTotalPages(Question_ListData?.totalPages);
          setPageJump(Question_ListData?.number);
          setNumberOfElement(Question_ListData?.totalElements);
          setPageSize(Question_ListData?.size);
        }
        break;

      default:
        break;
    }
  };

  // Fetch data based on the selected tab
  const fetchTabData = async (
    tabName,
    field,
    currentSortOrder,
    pageNo,
    pageSize
  ) => {
    let tabData = [];
    setShowLoader(true);
    const data = {
      searchText: "",
      ...(field !== "" ? { sortBy: field } : {}),
      ...(currentSortOrder !== "" ? { sortOrder: currentSortOrder } : {}),
      pageSize: pageSize,
      pageNumber: pageNo,
    };
    // API calls
    await fetchData(tabName, data);

    if (tabData) {
      setShowLoader(false);
      setTabContent({ ...tabContent, [tabName]: tabData.content });
    }
  };

  //pagination
  const fetchpaginationData = async (tabName, currPage) => {
    setShowLoader(true);
    const data = {
      pageSize: pageSize,
      pageNumber: currPage,
      searchText: "",
      ignorePagination: false,
    };
    // API calls
    await fetchData(tabName, data);
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      fetchpaginationData(activeTab, currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      fetchpaginationData(activeTab, currentPage - 1);
    }
  };

  const setPage = (e) => {
    if (e.target.value > 0 && e.target.value <= totalPages) {
      setPageJump(e.target.value - 1);
    }
  };

  const handleKeyPress = (event) => {
    event.preventDefault();
    fetchpaginationData(activeTab, pageJump);
  };

  const setPriority = async (event, id) => {
    const data = event.target.value;
    const response = await setLangPriority(data, id);
    if (response.status === 200) {
      toast.success(response.data.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
        style: { color: "#333333", fontWeight: "bold" },
      });
    } else {
      toast.error(response.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
        style: { color: "#333333", fontWeight: "bold" },
      });
    }
  };

  const IconsGroup = ({ data }) => {
    return (
      <div className="action-icons-group">
        <span
          className="table-icon"
          onClick={(e) => {
            e.stopPropagation();
            openviewPopup(data);
          }}
        >
          <img src={viewIcon} alt="icon" />
        </span>
        {permission === "edit" ? (
          <>
            <span
              className={`table-icon ${
                activeTab === "Onboarding" && activeSubTab === "Questions"
                  ? "disableIcons"
                  : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                if (
                  activeTab !== "Onboarding" ||
                  (activeTab === "Onboarding" && activeSubTab !== "Questions")
                ) {
                  openEditPopup(data);
                }
              }}
            >
              <img src={editIcon} alt="icon" />
            </span>
            <span
              className={`table-icon ${
                activeTab === "Onboarding" && activeSubTab === "Questions"
                  ? "disableIcons"
                  : ""
              }`}
              onClick={(e) => {
                e.stopPropagation();
                if (
                  activeTab !== "Onboarding" ||
                  (activeTab === "Onboarding" && activeSubTab !== "Questions")
                ) {
                  deletepopup(data);
                }
              }}
            >
              <img src={deleteIcon} alt="icon" />
            </span>
          </>
        ) : (
          ""
        )}
      </div>
    );
  };

  const SortIconStyle = (columnName) => {
    const col = columnName.columnName;
    return (
      <button
        className="filter-icon"
        onClick={(e) => {
          // e.stopPropagation();
          filterchanges(activeTab, col);
        }}
      >
        {sortOrders["name"] === "asc" && (
          <img src={filter_alt} alt="Ascending" />
        )}
        {sortOrders["name"] === "desc" && <img src={desc} alt="Descending" />}
        {!sortOrders["name"] && <img src={sort} alt="No Sorting" />}
      </button>
    );
  };

  const DevicesOrder = ({ uniqueSizes }) => {
    const desiredOrder = ["Mobile", "Tablet", "TV", "Web"];

    const orderMap = {};
    desiredOrder.forEach((value, index) => {
      orderMap[value] = index;
    });

    const sortedDevices = uniqueSizes.sort((a, b) => {
      return orderMap[a] - orderMap[b];
    });
    return (
      <>
        {sortedDevices.map((img, index) => (
          <span className="img-icon" key={index}>
            {" "}
            {img}
          </span>
        ))}
      </>
    );
  };
  const truncateDescription = (text, maxLength = 50) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + "...";
  };

  const handleEnableToggle = async (event, data) => {
    console.log("value", event.target.value);
    const list =
      activeSubTab === "Questions"
        ? questionData
        : activeSubTab === "Avatars"
        ? avatarData
        : posterData;
    const inProgressTableData = list.map((row) =>
      row.id === data ? { ...row, activeProgress: true } : row
    );
    if (activeSubTab === "Questions") {
      setQuestionData(inProgressTableData);
    } else if (activeSubTab === "Avatars") {
      setAvatarData(inProgressTableData);
    } else {
      setPosterData(inProgressTableData);
    }

    const url =
      activeSubTab === "Questions"
        ? ActiveInactiveQuestion_URL
        : activeSubTab === "Avatars"
        ? ActiveInactiveAvatar_URL
        : ActiveInactivePoster_URL;
    let res = await SetActiveInactive(
      url,
      data,
      event.target.value === "true" ? false : true
    );

    if (res?.status) {
      const updatedTableData = list.map((row) =>
        row.id === data
          ? {
              ...row,
              activeProgress: false,
              active: event.target.value === "true" ? false : true,
            }
          : row
      );
      if (activeSubTab === "Questions") {
        setQuestionData(updatedTableData);
      } else if (activeSubTab === "Avatars") {
        setAvatarData(updatedTableData);
      } else {
        setPosterData(updatedTableData);
      }

      toast.success(res?.data?.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
        style: { color: "#333333", fontWeight: "bold" },
      });
    } else {
      toast.error(res?.response?.data?.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
        style: { color: "#333333", fontWeight: "bold" },
      });
      if (activeSubTab === "Questions") {
        setQuestionData(questionData);
      } else if (activeSubTab === "Avatars") {
        setAvatarData(avatarData);
      } else {
        setPosterData(posterData);
      }
    }
  };

  async function handlePageSize(value) {
    let val = value?.target ? value.target.value : value;
    setPageSize(val);
    const data = {
      searchText: "",
      sortBy: "name",
      sortOrder: "asc",
      pageSize: val,
      pageNumber: pageJump,
      ignorePagination: false,
    };
    let tabName = activeTab;
    if (tabName === "Onboarding") {
      tabName = activeSubTab;
    }
    await fetchData(tabName, data);
  }

  const MasterSettingsTable = () => {
    return (
      <>
        <table className="master-setting-list cms-table-list channel-table">
          {
            <thead>
              <tr>
                <th>
                  Title
                  <SortIconStyle columnName="name" />
                </th>
                <th>Description</th>
                {activeTab !== "Maturity Ratings" && <th>Images</th>}
                {activeTab === "Languages" && <th>Priority</th>}
                <th>Action</th>
              </tr>
            </thead>
          }
          <tbody>
            {masterSettingsData.length !== 0
              ? masterSettingsData.map((data, index) => {
                  let selectedObject = {};
                  let uniqueSizes = [];

                  if (activeTab === "Themes") {
                    const mobileObject = data?.images.find(
                      (obj) => obj.size === "Mobile"
                    );
                    // If mobileObject exists, use it; otherwise, take the first object
                    selectedObject =
                      mobileObject ||
                      (data?.images.length !== 0 && data.images[0]);

                    uniqueSizes = [
                      ...new Set(data.images.map((img) => img.size)),
                    ];
                  } else {
                    if (activeTab !== "Maturity Ratings") {
                      const mobileObject = data?.iconImages?.find(
                        (obj) => obj.size === "Mobile"
                      );

                      selectedObject =
                        data?.iconImages?.length !== 0
                          ? data.iconImages[1]
                          : mobileObject ||
                            data?.posterImages?.find(
                              (obj) => obj.size === "Mobile"
                            ) ||
                            data.posterImages[0];

                      const iconSizes = new Set(
                        data?.iconImages?.map((img) => img.size)
                      );
                      const posterSizes = new Set(
                        data?.posterImages?.map((img) => img.size)
                      );
                      const allSizes = [...iconSizes, ...posterSizes];

                      // Filtering to get unique sizes
                      uniqueSizes = [...new Set(allSizes)];
                    }
                  }

                  return (
                    <tr key={data.id} onClick={() => openviewPopup(data)}>
                      <td
                        class={`${
                          activeTab === "Maturity Ratings" ? "colName" : ""
                        }  `}
                      >
                        {activeTab !== "Maturity Ratings" ? (
                          activeTab === "Categories" ? (
                            <div className="catcol">
                              {" "}
                              <div className="catagoryImage">
                                <img
                                  src={
                                    selectedObject
                                      ? cloudFront_URL +
                                        (selectedObject
                                          ? selectedObject.sourcePath
                                          : data.images[1]?.sourcePath)
                                      : img_thumb
                                  }
                                  alt={""}
                                />
                              </div>
                              <div> {data.name}</div>
                            </div>
                          ) : (
                            <>
                              <img
                                src={
                                  selectedObject
                                    ? cloudFront_URL +
                                      (selectedObject
                                        ? selectedObject.sourcePath
                                        : data.images[1]?.sourcePath)
                                    : img_thumb
                                }
                                className={`${
                                  activeTab === "Languages" ? "lang-image" : ""
                                } theme-image`}
                                alt={""}
                              />
                              {data.name}
                            </>
                          )
                        ) : (
                          data.name
                        )}
                      </td>
                      <td>
                        <div className="description" title={data.description}>
                          {truncateDescription(data.description)}
                        </div>
                      </td>
                      {activeTab !== "Maturity Ratings" && (
                        <td>
                          <DevicesOrder uniqueSizes={uniqueSizes} />
                        </td>
                      )}
                      {activeTab === "Languages" && (
                        <td>
                          <div className="form-col ">
                            <div
                              className="form-field"
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                            >
                              <DropDown
                                value={data.priority}
                                onChange={setPriority}
                                id={data.id}
                                options={priorityList}
                                name="priority"
                              />
                            </div>
                          </div>
                        </td>
                      )}
                      <td>
                        <IconsGroup data={data} />
                      </td>
                    </tr>
                  );
                })
              : ""}
          </tbody>
        </table>
        {/* pagination */}
        {numberOfElement > 0 ? (
          <Pagination
            currentPage={currentPage}
            pageSize={pageSize}
            numberOfElement={numberOfElement}
            handlePrev={handlePrev}
            handleKeyPress={handleKeyPress}
            setPage={setPage}
            totalPages={totalPages}
            handleNext={handleNext}
            handlePageSize={handlePageSize}
          />
        ) : null}
      </>
    );
  };
  const OnboardingTable = () => {
    return (
      <>
        <ul className="master-subTabs">
          {subTabs.map((subTab) => {
            return (
              <li
                className={`${activeSubTab === subTab ? "activeSubTab" : ""}`}
                key={subTab}
                onClick={() => handleSubTabChange(subTab)}
              >
                {subTab}
              </li>
            );
          })}
        </ul>
        <div className="onboardingtableScroll">
          <table className="master-setting-list cms-table-list channel-table onboardingTable">
            {
              <thead>
                <tr>
                  {columns[activeSubTab].map((col, index) => {
                    return <th key={index}>{col}</th>;
                  })}
                </tr>
              </thead>
            }

            <tbody>
              {(activeSubTab === "Avatars" && permission === "edit") &&
                (avatarData.length !== 0
                  ? avatarData?.map((data) => {
                      return (
                        <tr key={data.id} onClick={() => openviewPopup(data)}>
                          <td>
                            <img
                              src={
                                data?.sourcePath
                                  ? cloudFront_URL + data?.sourcePath
                                  : img_thumb
                              }
                              className="theme-image"
                              alt={""}
                            />
                            {data?.name}
                          </td>
                          <td>{data?.gender?.name}</td>
                          <td>{data?.userGroup?.name}</td>
                          <td>
                            {data?.peerGroup !== null
                              ? data?.peerGroup?.ageGroup +
                                " (" +
                                data?.peerGroup?.name +
                                ")"
                              : ""}
                          </td>

                          <td>
                            {" "}
                            <div className="table-action-group channel-action-group">
                              <div
                                className="switch-check"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {data.activeProgress ? (
                                  <span className="switch-loader"></span>
                                ) : null}
                                {permission === "edit" ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      checked={data.active}
                                      value={data.active}
                                      onChange={(event) => {
                                        event.stopPropagation();
                                        handleEnableToggle(event, data.id);
                                      }}
                                      id={data.id}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                    />
                                    <label
                                      htmlFor={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    ></label>
                                  </>
                                ) : permission === "read" ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      checked={data.active}
                                      value={data.active}
                                      disabled
                                      id={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                    <label
                                      htmlFor={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    ></label>
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </td>
                          <td>
                            <IconsGroup data={data} />
                          </td>
                        </tr>
                      );
                    })
                  : "")}

              {activeSubTab === "Posters" &&
                (posterData.length !== 0
                  ? posterData?.map((data) => {
                      return (
                        <tr key={data.id} onClick={() => openviewPopup(data)}>
                          <td>
                            <img
                              src={
                                data?.sourcePath
                                  ? cloudFront_URL + data?.sourcePath
                                  : img_thumb
                              }
                              className="theme-image"
                              alt={""}
                            />
                            {data?.name}
                          </td>
                          <td>
                            {data.audioLanguages.map((lang, index) => {
                              if (index > 0) {
                                return <span key={index}>, {lang.name}</span>;
                              } else {
                                return <span key={index}>{lang.name}</span>;
                              }
                            })}
                          </td>
                          <td>
                            {data.categories.map((category, index) => {
                              if (index > 0) {
                                return (
                                  <span key={index}>, {category.name}</span>
                                );
                              } else {
                                return <span key={index}>{category.name}</span>;
                              }
                            })}
                          </td>
                          <td>
                            {data.genres.map((category, index) => {
                              if (index > 0) {
                                return (
                                  <span key={index}>, {category.name}</span>
                                );
                              } else {
                                return <span key={index}>{category.name}</span>;
                              }
                            })}
                          </td>

                          <td>
                            {" "}
                            <div className="table-action-group channel-action-group">
                              <div
                                className="switch-check"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {data.activeProgress ? (
                                  <span className="switch-loader"></span>
                                ) : null}
                                {permission === "edit" ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      checked={data.active}
                                      value={data.active}
                                      onChange={(event) => {
                                        event.stopPropagation();
                                        handleEnableToggle(event, data.id);
                                      }}
                                      id={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                    <label
                                      htmlFor={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    ></label>
                                  </>
                                ) : permission === "read" ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      checked={data.active}
                                      value={data.active}
                                      disabled
                                      id={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                    <label
                                      htmlFor={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    ></label>
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </td>
                          <td>
                            <IconsGroup data={data} />
                          </td>
                        </tr>
                      );
                    })
                  : "")}

              {activeSubTab === "Questions" &&
                (questionData.length !== 0
                  ? questionData?.map((data) => {
                      return (
                        <tr key={data.id} onClick={() => openviewPopup(data)}>
                          <td style={{ paddingLeft: 76 }}>{data?.question}</td>
                          <td>{data?.subheading}</td>
                          <td>{data?.questionType}</td>
                          <td>{data?.includeIcons ? "Yes" : "No"}</td>

                          <td>
                            {" "}
                            <div className="table-action-group channel-action-group">
                              <div
                                className="switch-check"
                                onClick={(e) => e.stopPropagation()}
                              >
                                {data.activeProgress ? (
                                  <span className="switch-loader"></span>
                                ) : null}
                                {permission === "edit" ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      checked={data.active}
                                      value={data.active}
                                      onChange={(event) => {
                                        event.stopPropagation();
                                        handleEnableToggle(event, data.id);
                                      }}
                                      id={data.id}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                      }}
                                    />
                                    <label
                                      htmlFor={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    ></label>
                                  </>
                                ) : permission === "read" ? (
                                  <>
                                    <input
                                      type="checkbox"
                                      checked={data.active}
                                      value={data.active}
                                      disabled
                                      id={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                    <label
                                      htmlFor={data.id}
                                      onClick={(e) => e.stopPropagation()}
                                    ></label>
                                  </>
                                ) : null}
                              </div>
                            </div>
                          </td>
                          <td>
                            <IconsGroup data={data} />
                          </td>
                        </tr>
                      );
                    })
                  : "")}
            </tbody>
          </table>
          {/* pagination */}
          {numberOfElement > 0 ? (
            <Pagination
              currentPage={currentPage}
              pageSize={pageSize}
              numberOfElement={numberOfElement}
              handlePrev={handlePrev}
              handleKeyPress={handleKeyPress}
              setPage={setPage}
              totalPages={totalPages}
              handleNext={handleNext}
              handlePageSize={handlePageSize}
            />
          ) : null}
        </div>
      </>
    );
  };

  return permission !== null ? (
    <div className="content-body dark">
      <div className="dashboard-content dark">
        <div className="top-content master-setting-content">
          <div className="left-side">
            <h3 className="title">Master Settings</h3>
          </div>
          <div className="right-side">
            {permission === "edit" &&
            (activeTab !== "Onboarding" ||
              (activeTab === "Onboarding" && activeSubTab !== "Questions")) ? (
              <div className="channel-setup-button">
                <button
                  className="btn btn-primary addIcon"
                  onClick={openCreatePopup}
                >
                  <img src={addIcon} alt="add" /> Add New
                  {/* {activeTab} */}
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>

        <>
          <div className="setting-genre channel-category master-settings-tabs">
            <ul className="channel-category-tab master-tabs">
              {tabs.map((tab) => {
                if (tab === "Onboarding" && permission !== "edit") return null;
                return (
                  <li
                    className={`${activeTab === tab ? "active" : ""}`}
                    key={tab}
                    onClick={() => handleTabChange(tab)}
                  >
                    {tab}
                  </li>
                );
              })}
            </ul>
          </div>
          {ShowLoader ? (
            <div
              style={{
                background: "#121212",
                border: "none",
                height: "78vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 9999,
                borderRadius: "8px",
                marginTop: "0px",
              }}
            >
              <Loader />
            </div>
          ) : (
            <div
              className={`${
                activeTab === "Onboarding"
                  ? "master-setting-table onboarding-Table"
                  : "master-setting-table"
              } channel-content channel-setup-table`}
            >
              {/* table */}
              {activeTab === "Onboarding" ? (
                <OnboardingTable />
              ) : (
                <MasterSettingsTable />
              )}
            </div>
          )}
        </>

        <ToastContainer />

        {showPopup && (
          <AddEditSettingspopup
            TabChange={handleTabChange}
            tab={activeTab}
            subTab={activeTab === "Onboarding" ? activeSubTab : ""}
            show={showPopup}
            handleClose={closePopup}
            isEditing={createEdit === "edit"} // Pass true if editing, false if creating
            gridData={singledata}
            onlyview={viewonly}
            openEdit={() => {
              openEditPopup(singledata);
            }}
          />
        )}
        {errorbox && (
          <ErrorPopup
            btntext="Delete"
            message={errorMssage}
            closebox={() => errorboxclose()}
            overrides={() => deletesetting(deletedata)}
          />
        )}
      </div>
    </div>
  ) : (
    ""
  );
}

export default MasterSettings;
